import * as React from 'react'
import FooterShadow from '../images/footer-shadow.svg'
import FooterShadowDesktop from '../images/footer-shadow-desktop.svg'
import PoapBadge from '../images/POAP.svg'
import { SmartBanner } from 'backoffice/SmartBanner/SmartBanner'

export const ClaimFooter: React.FC = () => (
  <footer role="contentinfo" className="footer-events white-background">
    <div className="image-footer">
      <img src={FooterShadow} className="mobile" alt="" />
      <img src={FooterShadowDesktop} className="desktop" alt="" />
    </div>
    <div className="footer-content">
      <div className="container">
        <a href={'https://www.poap.xyz'} target={'_blank'}>
          <img src={PoapBadge} alt="" className="decoration" />
        </a>
        <SmartBanner />
      </div>
    </div>
  </footer>
)
